<template>
  <div :class="classObj" class="app-select-chevron"></div>
</template>

<script>
export default {
  name: "AppSelectChevron",
  props: {
    opened: Boolean,
    invalid: Boolean
  },
  computed: {
    classObj() {
      return {
        "is-opened": this.opened,
        "is-invalid": this.invalid
      };
    }
  }
};
</script>

<style lang="scss">
.app-select-chevron {
  transition: 0.4s;

  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;

  border-top: 7px solid currentColor;

  &.is-opened {
    transform: rotateX(180deg);
  }
}
</style>
